import { Injectable, EventEmitter, HostListener } from '@angular/core';
import { TranslatePipe } from '../pipes/translate.pipe';
import { FiltersPipe } from '../pipes/filters.pipe';
import { LocalizationService } from '../services/localization.service';
import { removeUniquePipe } from '../pipes/reducer.pipe';
import { GroupByTournamentId } from '../pipes/grouplivefixturebytournamentid';
import { BehaviorSubject } from 'rxjs';
import { DefaultSlipAmount } from '../../environments/environment';
import { GroupByEventName } from '../pipes/groupbyeventname.pipe';
export interface ISelectedWallet {
  CustomerId: number;
  BranchId: number;
  BranchType: number;
  BrancName: string;
  Balance: number;
  ExtensionData: object;
  IsVerification: boolean;
  IsResetActive: boolean;
  TaxRate: number;
  IsShufa: boolean;
  IsFin: boolean;
}

@Injectable()
export class DataHelper {
  // bet3000
  depositLimitDialogState = true;
  oldCouponList = [];
  selectedWallet: ISelectedWallet = {
    CustomerId: 0,
    BranchId: 0,
    BranchType: 0,
    BrancName: '',
    Balance: 0,
    ExtensionData: {},
    IsVerification: true,
    TaxRate: 0,
    IsShufa: false,
    IsFin: false,
    IsResetActive: false,
  };
  isSelectOdd = false;

  // May be shop value change next time.Now 1;
  isOutRights;
  selectedStoryItem;
  selectedStorySportId = 1; // 1 = Soccer
  selectedStoryIndex = 0; // Index => 0 Soccer
  selectedStorySportAllItem = { OrginalName: 'Soccer', SportName: 'Soccer' };
  comboSelectedOdd = { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] };
  allSportsMenuSelectedTimeFilter = 300;
  // bet3000

  selectedMatch: any;

  // Routing kalktığı için type tutuldu.1 eventdetail 2 livedetail
  LeagueDataListener: EventEmitter<any> = new EventEmitter();
  LeagueData: Array<any>;
  leftMenuSportDataListener: EventEmitter<any> = new EventEmitter();
  leftMenuSportData: Array<any>;
  leftMenuSportDayFilter: number;
  searchDataListener: EventEmitter<any> = new EventEmitter();
  searchDataUrlListener: EventEmitter<any> = new EventEmitter();
  searchData: Array<any>;
  liveData: Array<any> = [];
  liveDataListener: EventEmitter<any> = new EventEmitter();
  cardData: Array<any>;
  cardDataListener: EventEmitter<any> = new EventEmitter();
  liveEventDetailData: Array<any>;
  liveEventDetailListener: EventEmitter<any> = new EventEmitter();

  liveEventDataRebuildedListener: EventEmitter<any> = new EventEmitter();
  liveEventDataRebuilded;

  liveEventDataRebuildedListenerUnfiltered: EventEmitter<any> = new EventEmitter();
  liveEventDataRebuildedUnfiltered;

  liveFilterItemsListener: EventEmitter<any> = new EventEmitter();
  liveFilterItems;
  liveSortbyTime = false;

  currentSlipDataListener: EventEmitter<any> = new EventEmitter();
  currentSlipData: Array<any> = [];

  numberOfBetsListener: EventEmitter<any> = new EventEmitter();
  numberOfBets: any;
  taxRate = 0;

  currentSlipOpened = false;

  groupByTournamentId = new GroupByTournamentId();
  cashoutDataListener: EventEmitter<any> = new EventEmitter();
  cashoutData: Array<any>;

  numberOfCashoutListener: EventEmitter<any> = new EventEmitter();
  numberOfCashout: any;

  sideBannerDataListener: EventEmitter<any> = new EventEmitter();
  sideBannerData: any;

  DataCustomerTicketList = [];
  DataCustomerTicketDetailList = [];

  ChangeOddIsActive = true;

  liveFavoriteTournamentList: Array<any> = [];

  liveFavoriteButtonStatus = false;

  liveGoalListData: any[] = [];
  liveGoalListDataListener: EventEmitter<any> = new EventEmitter();

  liveFavouriteStateChanged: EventEmitter<any> = new EventEmitter();

  homeHighlightsFixture = new BehaviorSubject<any>([]);
  homeSliderData = [];
  homeSliderDataListener: EventEmitter<any> = new EventEmitter();

  currentSlipAmount: any;
  currentSlipAmountListener: EventEmitter<any> = new EventEmitter();

  currentSlipSystemInfo: any = [];
  currentSlipSystemInfoListener: EventEmitter<any> = new EventEmitter();

  /**
   * @desc: Betting slip system bet selections
   */
  currentSlipSystemSelection: any = [];

  cashoutSlipsList: any = [];
  oldCashoutSlipsList: any = [];

  cashoutTimeLineData: { [key: number]: any } = {};

  public currentSlipInfo = {
    toPay: 0,
    toPayNumeric: 0,
    currentslip_totalStake: DefaultSlipAmount,
    currentTotalRate: 0,
    tax: '',
    amountPerBet: 0,
    numberOfBets: 0,
    maxGain: 0,
    minGain: 0,
    totalRate: 0,
    oddIsChange: false,
    isMultiWaySystem: false,
    isCheckIsSystem: false,
  };

  comparisonData = [];
  comparisonDataListener: EventEmitter<any> = new EventEmitter();

  homeMainData = [];
  mainData = [];
  storySportsData = [
    {
      imageUrl: 'basketball.svg',
      pngUrl: 'basketball.png',
      SportName: 'Basketball',
      selected: false,
    },
    {
      imageUrl: 'soccer.svg',
      pngUrl: 'soccer.png',
      SportName: 'Soccer',
      selected: false,
    },
    {
      imageUrl: 'baseball.svg',
      pngUrl: 'baseball.png',
      SportName: 'Baseball',
      selected: false,
    },
    {
      imageUrl: 'football.svg',
      pngUrl: 'football.png',
      SportName: 'Football',
      selected: false,
    },
    {
      imageUrl: 'tennis.svg',
      pngUrl: 'tennis.png',
      SportName: 'Tennis',
      selected: false,
    },
    {
      imageUrl: 'volleyball.svg',
      pngUrl: 'volleyball.png',
      SportName: 'Volleyball',
      selected: false,
    },
    {
      imageUrl: 'icehokey.svg',
      pngUrl: 'icehockey.png',
      SportName: 'Ice Hockey',
      selected: false,
    },
    {
      imageUrl: 'handball.svg',
      pngUrl: 'handball.png',
      SportName: 'Handball',
      selected: false,
    },
    {
      imageUrl: 'rugby.svg',
      pngUrl: 'rugby.png',
      SportName: 'Rugby',
      selected: false,
    },
    {
      imageUrl: 'aussierules.svg',
      pngUrl: 'aussierules.png',
      SportName: 'Aussie rules',
      selected: false,
    },
    {
      imageUrl: 'snooker.svg',
      pngUrl: 'snooker.png',
      SportName: 'Snooker',
      selected: false,
    },
    {
      imageUrl: 'tabletennis.svg',
      pngUrl: 'tabletennis.png',
      SportName: 'Table tennis',
      selected: false,
    },
    {
      imageUrl: 'cricket.svg',
      pngUrl: 'cricket.png',
      SportName: 'Cricket',
      selected: false,
    },
    {
      imageUrl: 'darts.svg',
      pngUrl: 'darts.png',
      SportName: 'Darts',
      selected: false,
    },
    {
      imageUrl: 'futsal.svg',
      pngUrl: 'futsal.png',
      SportName: 'Futsal',
      selected: false,
    },
    {
      imageUrl: 'badminton.svg',
      pngUrl: 'badminton.png',
      SportName: 'Badminton',
      selected: false,
    },
    {
      imageUrl: 'bowls.svg',
      pngUrl: 'bowls.png',
      SportName: 'Bowls',
      selected: false,
    },
    {
      imageUrl: 'beachvolley.svg',
      pngUrl: 'beachvolley.png',
      SportName: 'Beach Volley',
      selected: false,
    },
    {
      imageUrl: 'squash.svg',
      pngUrl: 'squash.png',
      SportName: 'Squash',
      selected: false,
    },
    {
      imageUrl: 'csgo.svg',
      pngUrl: 'csgo.png',
      SportName: 'ESport Counter-Strike', //  CS:GO
      selected: false,
    },
    {
      imageUrl: 'lol.svg',
      pngUrl: 'lol.png',
      SportName: 'ESport League of Legends', // LOL
      selected: false,
    },
    {
      imageUrl: 'dota2.svg',
      pngUrl: 'dota2.png',
      SportName: 'DOTA 2',
      selected: false,
    },
    {
      imageUrl: 'motorsport.svg',
      pngUrl: 'motorsport.png',
      SportName: 'Motor sport',
      selected: false,
    },
    {
      imageUrl: 'boxing.svg',
      pngUrl: 'boxing.png',
      SportName: 'Boxing',
      selected: false,
    },
    {
      imageUrl: 'waterpolo.svg',
      pngUrl: 'waterpolo.png',
      SportName: 'Waterpolo',
      selected: false,
    },
    {
      imageUrl: 'icehokey.svg',
      pngUrl: 'icehockey.png',
      SportName: 'Field Hockey',
      selected: false,
    },
  ];

  oddTypes = [
    {
      // 0
      all: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: 'x',
          type: '2',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Boxing: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Badminton: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Football: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Motor sport': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Darts: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Alpine: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Aussie rules': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Cricket: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: '1',
          Gname: 'tipp',
        },
        {
          preText: '2',
          type: '3',
          Gname: 'tipp',
        },
      ],
    },
    {
      // 1
      all: [
        {
          preText: '1',
          type: 'Hadicap01_1',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_1',
          set: { mLine: true, perLine: 3 },
        },
        {
          preText: 'X',
          type: 'Hadicap01_X',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'Hadicap01_2',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'Hadicap02_1',
          Gname: 'Handicap',
          lineText: 'Hadicap02_1',
          line: '2',
        },
        {
          preText: 'X',
          type: 'Hadicap02_X',
          Gname: 'Handicap',
          line: '2',
        },
        {
          preText: '2',
          type: 'Hadicap02_2',
          Gname: 'Handicap',
          line: '2',
        },
        {
          preText: '1',
          type: 'Hadicap10_1',
          Gname: 'Handicap',
          line: '3',
          lineText: 'Hadicap10_1',
        },
        {
          preText: 'X',
          type: 'Hadicap10_X',
          Gname: 'Handicap',
          line: '3',
        },
        {
          preText: '2',
          type: 'Hadicap10_2',
          Gname: 'Handicap',
          line: '3',
        },
        {
          preText: '1',
          type: 'Hadicap20_1',
          Gname: 'Handicap',
          lineText: 'Hadicap20_1',
          line: '4',
        },
        {
          preText: 'X',
          type: 'Hadicap20_X',
          Gname: 'Handicap',
          line: '4',
        },
        {
          preText: '2',
          type: 'Hadicap20_2',
          Gname: 'Handicap',
          line: '4',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'Hadicap01_1',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preText: '2',
          type: 'Hadicap01_2',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'Hadicap02_1',
          Gname: 'Handicap',
          lineText: 'Hadicap02_1',
          line: '2',
        },
        {
          preText: '2',
          type: 'Hadicap02_2',
          Gname: 'Handicap',
          line: '2',
        },
        {
          preText: '1',
          type: 'Hadicap10_1',
          Gname: 'Handicap',
          lineText: 'Hadicap10_1',
          line: '3',
        },
        {
          preText: '2',
          type: 'Hadicap10_2',
          Gname: 'Handicap',
          line: '3',
        },
        {
          preText: '1',
          type: 'Hadicap20_1',
          Gname: 'Handicap',
          lineText: 'Hadicap20_1',
          line: '4',
        },
        {
          preText: '2',
          type: 'Hadicap20_2',
          Gname: 'Handicap',
          line: '4',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'Hadicap01_1',
          Gname: 'Handicap',
          line: '1',
          lineText: 'Hadicap01_1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preText: '2',
          type: 'Hadicap01_2',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'Hadicap02_1',
          Gname: 'Handicap',
          lineText: 'Hadicap02_1',
          line: '2',
        },
        {
          preText: '2',
          type: 'Hadicap02_2',
          Gname: 'Handicap',
          line: '2',
        },
        {
          preText: '1',
          type: 'Hadicap10_1',
          Gname: 'Handicap',
          lineText: 'Hadicap10_1',
          line: '3',
        },
        {
          preText: '2',
          type: 'Hadicap10_2',
          Gname: 'Handicap',
          line: '3',
        },
        {
          preText: '1',
          type: 'Hadicap20_1',
          Gname: 'Handicap',
          lineText: 'Hadicap20_1',
          line: '4',
        },
        {
          preText: '2',
          type: 'Hadicap20_2',
          Gname: 'Handicap',
          line: '4',
        },
      ],
    },
    {
      // 2
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O1_5',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'Totals_O1_5',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U1_5',
          Gname: 'Over/Under',
          line: '1',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O2_5',
          Gname: 'Over/Under',
          lineText: 'Totals_O2_5',
          line: '2',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U2_5',
          Gname: 'Over/Under',
          line: '2',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O3_5',
          Gname: 'Over/Under',
          lineText: 'Totals_O3_5',
          line: '3',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U3_5',
          Gname: 'Over/Under',
          line: '3',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Totals_O4_5',
          Gname: 'Over/Under',
          lineText: 'Totals_O4_5',
          line: '4',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Totals_U4_5',
          Gname: 'Over/Under',
          line: '4',
        },
      ],
      Tennis: [
        {
          preTextT: 'Over_abrr',
          type: 'TennisTotal_O',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'TennisTotal',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TennisTotal_U',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Basketball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'BasketTotal',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Baseball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Über/Unter',
          line: '1',
          lineText: 'Total1',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Über/Unter',
          lineText: 'TotalOne',
          line: '1',
        },
      ],
    },
    {
      // 3
      all: [
        {
          preText: '1X',
          type: 'Double_1X',
          Gname: 'DoppelteChance',
        },
        {
          preText: '12',
          type: 'Double_12',
          Gname: 'DoppelteChance',
        },
        {
          preText: 'X2',
          type: 'Double_X2',
          Gname: 'DoppelteChance',
        },
      ],
    },
    {
      // 4
      all: [
        {
          preTextT: 'yes_unabrr',
          type: 'Both_Y',
          Gname: 'Treffenbeide?',
        },
        {
          preTextT: 'no_unabrr',
          type: 'Both_N',
          Gname: 'Treffenbeide?',
        },
      ],
    },
    {
      // 5
      all: [
        {
          preText: '1',
          type: 'FirstScore_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstScore_None',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstScore_2',
          Gname: 'NT',
        },
      ],
    },
    {
      // 6
      all: [
        {
          preText: '1',
          type: 'FirstHalf_1',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: 'x',
          type: 'FirstHalf_X',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: '2',
          type: 'FirstHalf_2',
          Gname: 'TIPP 1.HZ',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'BasketFirstHalf_1',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: 'x',
          type: 'BasketFirstHalf_X',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: '2',
          type: 'BasketFirstHalf_2',
          Gname: 'TIPP 1.HZ',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'TennisFirstSet_1',
          Gname: 'TIPP 1.HZ',
        },
        {
          preText: '2',
          type: 'TennisFirstSet_2',
          Gname: 'TIPP 1.HZ',
        },
      ],
    },
    {
      // 7
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'FirstHalfTotalsO_0_5',
          Gname: 'Ü/U 1.HZ',
          line: '1',
          lineText: 'FirstHalfTotalsO_0_5',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'FirstHalfTotalsU_0_5',
          line: '1',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Over_abrr',
          type: 'FirstHalfTotalsO_1_5',
          line: '2',
          lineText: 'FirstHalfTotalsO_1_5',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Under_abrr',
          type: 'FirstHalfTotalsU_1_5',
          line: '2',
          Gname: 'Ü/U 1.HZ',
        },
      ],
    },
    {
      // 8
      all: [
        {
          preText: '1',
          type: 'FirstScore_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstScore_None',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstScore_2',
          Gname: 'NT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstScore_1',
          Gname: 'NT',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstScore_None',
          Gname: 'NT',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstScore_2',
          Gname: 'NT',
          specialIsActive: false,
        },
      ],
    },
    {
      // 9
      all: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'rThreeWay',
          Notes: 'no diff on sports type',
          lineText: 'Totals_O1_5',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'rThreeWay',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'rThreeWay',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'rThreeWay',
          Notes: 'no diff on sports type',
          lineText: 'Totals_O1_5',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'rThreeWay',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'rThreeWay',
          specialIsActive: false,
        },
      ],
      'Motor sport': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Ice Hockey': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],

      'Field Hockey': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Darts: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
    },
    {
      // 10
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'TotalOneOver',
          Gname: 'Über/Unter',
          line: '1',
          lineText: 'TotalOne',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalOneUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalOne',
          line: '1',
        },
        {
          preTextT: 'Over_abrr',
          type: 'TotalTwoOver',
          Gname: 'Über/Unter',
          lineText: 'TotalTwo',
          line: '2',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalTwoUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalTwo',
          line: '2',
        },

        {
          preTextT: 'Over_abrr',
          type: 'TotalThreeOver',
          Gname: 'Über/Unter',
          lineText: 'TotalThree',
          line: '3',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalThreeUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalThree',
          line: '3',
        },
        {
          preTextT: 'Over_abrr',
          type: 'TotalFourOver',
          Gname: 'Über/Unter',
          lineText: 'TotalFour',
          line: '4',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalFourUnder',
          Gname: 'Über/Unter',
          lineText: 'TotalFour',
          line: '4',
        },
      ],
      Tennis: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Über/Unter',
          line: '1',
          lineText: 'Total1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Über/Unter',
          lineText: 'Total1',
          line: '1',
        },
        {
          preTextT: 'Over_abrr',
          type: 'Total2Over',
          Gname: 'Über/Unter',
          lineText: 'Total2',
          line: '2',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total2Under',
          Gname: 'Über/Unter',
          lineText: 'Total2',
          line: '2',
        },

        {
          preTextT: 'Over_abrr',
          type: 'Total3Over',
          Gname: 'Über/Unter',
          lineText: 'Total3',
          line: '3',
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total3Under',
          Gname: 'Über/Unter',
          lineText: 'Total3',
          line: '3',
        },
      ],
      Basketball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'TennisTotal',
          set: { mLine: true, lineLeftText: 'BasketTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Volleyball: [
        {
          preTextT: 'Over_abrr',
          type: 'TennisTotal_O',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'TennisTotal',
          set: { mLine: true, lineLeftText: 'TennisTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TennisTotal_U',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
    },
    {
      // 11
      all: [
        {
          preText: '1',
          type: 'FirstHalf_1',
          Gname: '1x2 HT',
        },
        {
          preText: 'x',
          type: 'FirstHalf_X',
          Gname: '1x2 HT',
        },
        {
          preText: '2',
          type: 'FirstHalf_2',
          Gname: '1x2 HT',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: '1x2 HT',
        },
        {
          preText: '2',
          type: 'TennisFirstSet2',
          Gname: '1x2 HT',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: '1x2 HT',
        },
        {
          preText: '2',
          type: 'TennisFirstSet2',
          Gname: '1x2 HT',
        },
      ],
    },
    {
      // 12
      all: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'NT',
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'NT',
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'NT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'NT_HZ',
          specialIsActive: false,
        },
      ],
    },
    {
      // 13
      all: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: 'x',
          type: 'FirstHalfRS_X',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Soccer: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
          specialIsActive: false,
        },
        {
          preText: 'x',
          type: 'FirstHalfRS_X',
          Gname: 'RoM HT',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
          specialIsActive: false,
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Motor sport': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: 'FirstHalfRS_1',
          Gname: 'RoM HT',
        },
        {
          preText: '2',
          type: 'FirstHalfRS_2',
          Gname: 'RoM HT',
        },
      ],
    },
    {
      // 14
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'HalfTotal1Over',
          Gname: 'Ü/U 1.HZ',
          line: '1',
          lineText: 'HalfTotal1',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'HalfTotal1Under',
          line: '1',
          lineText: 'HalfTotal1',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Over_abrr',
          type: 'HalfTotal2Over',
          line: '2',
          lineText: 'HalfTotal2',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Under_abrr',
          type: 'HalfTotal2Under',
          line: '2',
          lineText: 'HalfTotal2',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Over_abrr',
          type: 'HalfTotal3Over',
          line: '3',
          lineText: 'HalfTotal3',
          Gname: 'Ü/U 1.HZ',
        },
        {
          preTextT: 'Under_abrr',
          type: 'HalfTotal3Under',
          line: '3',
          lineText: 'HalfTotal3',
          Gname: 'Ü/U 1.HZ',
        },
      ],
    },
    {
      // 15
      all: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: 'x',
          type: 'RestThreeWayX',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Basketball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Darts: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Snooker: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Baseball: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Cross-Country': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Curling: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      Biathlon: [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
      'Short Track Speed Skating': [
        {
          preText: '1',
          type: 'RestThreeWay1',
          Gname: 'RoM',
        },
        {
          preText: '2',
          type: 'RestThreeWay2',
          Gname: 'RoM',
        },
      ],
    },
    {
      // 16
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'Total2Over',
          Gname: 'HomeTotal_Short',
          line: '1',
          lineText: 'Total2',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total2Under',
          Gname: 'HomeTotal_Short',
          line: '1',
          lineText: 'Total2',
        },
      ],
    },
    {
      // 17
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'Total3Over',
          Gname: 'AwayTotal_Short',
          line: '1',
          lineText: 'Total3',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total3Under',
          Gname: 'AwayTotal_Short',
          line: '1',
          lineText: 'Total3',
        },
      ],
    },
    {
      // 18 => Tennis Set ( Live ) , Volleyball Set
      all: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
        },
      ],
      Tennis: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
          specialIsActive: false,
        },
      ],
      Volleyball: [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
          specialIsActive: false,
        },
      ],
      'Table tennis': [
        {
          preText: '1',
          type: 'TennisFirstSet1',
          Gname: 'TennisSet_Long',
          specialIsActive: false,
        },
        {
          preText: '2',
          type: 'TennisFirstSet2', // DB deki isim
          Gname: 'TennisSet_Long', // Translate ve live.component teki karşılığı
          specialIsActive: false,
        },
      ],
    },
    {
      // 19 => IceHockey Period ( Live )
      all: [
        {
          preText: '1',
          type: 'FirstHalfNG_1',
          Gname: 'IceHockeyPeriod_Short',
        },
        {
          preText: 'x',
          type: 'FirstHalfNG_X',
          Gname: 'IceHockeyPeriod_Short',
        },
        {
          preText: '2',
          type: 'FirstHalfNG_2',
          Gname: 'IceHockeyPeriod_Short',
        },
      ],
    },
    {
      // 20 => Tennis Total Sets ( Live )
      all: [
        {
          preTextT: 'O',
          type: 'HalfTotal2Over',
          line: '1',
          lineText: 'HalfTotal2',
          Gname: 'TennisTotalSet_Short',
          set: { mLine: true, perLine: 2 },
        },
        {
          preTextT: 'U',
          type: 'HalfTotal2Under', // DB deki isim
          Gname: 'TennisTotalSet_Short', // Translate ve live.component teki karşılığı
          line: '1',
          lineText: 'HalfTotal2',
        },
      ],
    },
    {
      // 21 => Tennis Total Set ( Live )
      all: [
        {
          preText: 'O',
          type: 'FirstHalf_1',
          Gname: 'TennisTotalSet_Long',
        },
        {
          preText: 'U',
          type: 'FirstHalf_2',
          Gname: 'TennisTotalSet_Long',
        },
      ],
    },

    {
      // 22
      all: [
        {
          preText: '1',
          type: 'HandicapOneHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapOne',
          set: { mLine: true, perLine: 3 },
        },
        {
          preText: 'X',
          type: 'HandicapOneDraw',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'HandicapOneAway',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'HandicapTwoHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapTwo',
        },
        {
          preText: 'X',
          type: 'HandicapTwoDraw',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'HandicapTwoAway',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '1',
          type: 'HandicapThreeHome',
          Gname: 'Handicap',
          line: '1',
          lineText: 'HandicapThree',
        },
        {
          preText: 'X',
          type: 'HandicapThreeDraw',
          Gname: 'Handicap',
          line: '1',
        },
        {
          preText: '2',
          type: 'HandicapThreeAway',
          Gname: 'Handicap',
          line: '1',
        },
      ],
    },
    {
      // 23
      all: [
        {
          preText: '1X',
          type: 'Double1X',
          Gname: 'DoppelteChance',
        },
        {
          preText: '12',
          type: 'Double12',
          Gname: 'DoppelteChance',
        },
        {
          preText: 'X2',
          type: 'DoubleX2',
          Gname: 'DoppelteChance',
        },
      ],
    },
    {
      // 24
      all: [
        {
          preTextT: 'yes_unabrr',
          type: 'Both_Y',
          Gname: 'Treffenbeide?',
        },
        {
          preTextT: 'no_unabrr',
          type: 'Both_N',
          Gname: 'Treffenbeide?',
        },
      ],
    },
    {
      // 25, only first ou
      all: [
        {
          preTextT: 'Over_abrr',
          type: 'TotalSpread_O',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'BasketTotal',
          set: { mLine: true, lineLeftText: 'BasketTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'TotalSpread_U',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
      Basketball: [
        {
          preTextT: 'Over_abrr',
          type: 'Total1Over',
          Gname: 'Over/Under',
          line: '1',
          lineText: 'BasketTotal',
          set: { mLine: true, lineLeftText: 'BasketTotal', perLine: 2 },
        },
        {
          preTextT: 'Under_abrr',
          type: 'Total1Under',
          Gname: 'Over/Under',
          line: '1',
        },
      ],
    },
  ];

  _GroupByEventName = new GroupByEventName();

  constructor() {
    this.leftMenuSportDayFilter = 300;
  }

  setLeagueData(v: Array<any>) {
    // console.log('DATA--HELPER--setLeagueData',v);
    this.LeagueData = v;
    this.LeagueDataListener.emit(this.LeagueData);
  }
  setLiveData(v: Array<any>) {
    this.liveData = v;
    this.liveDataListener.emit(this.liveData);
  }

  setLiveEventRebuilded(e) {
    this.liveEventDataRebuilded = e;
    this.liveEventDataRebuildedListener.emit(this.liveEventDataRebuilded);
  }

  setLiveFilterItems(e) {
    this.liveFilterItems = e;
    this.liveFilterItemsListener.emit(this.liveFilterItems);
  }

  setLiveEventRebuildedUnfiltered(e) {
    this.liveEventDataRebuildedUnfiltered = e;
    this.liveEventDataRebuildedListenerUnfiltered.emit(this.liveEventDataRebuildedUnfiltered);
  }

  setLiveFavoriteTournamentData(e) {
    this.liveFavoriteTournamentList = e;
    localStorage.setItem('storage-live-favorite-tournamen-list', JSON.stringify(e));
  }

  getLiveFavoriteTournamentData(): Array<number> {
    this.liveFavoriteTournamentList = JSON.parse(localStorage.getItem('storage-live-favorite-tournamen-list'));
    if (this.liveFavoriteTournamentList == null) {
      this.liveFavoriteTournamentList = [];
    }
    return this.liveFavoriteTournamentList;
  }

  setFavoritesButtonStatus(status) {
    this.liveFavoriteButtonStatus = status;
    localStorage.setItem('storage-live-favorite-button', JSON.stringify(status));
    this.liveFavouriteStateChanged.emit();
  }

  getFavoritesButtonStatus() {
    const bStaus = localStorage.getItem('storage-live-favorite-button');

    if (bStaus == '' || bStaus == null) {
      localStorage.setItem('storage-live-favorite-button', JSON.stringify(false));
      this.liveFavoriteButtonStatus = false;
    } else {
      this.liveFavoriteButtonStatus = JSON.parse(bStaus);
    }
    return this.liveFavoriteButtonStatus;
  }

  webWorkerLiveJob = wwsConfig => {
    try {
      const filtersPipe = (items: any[], key: any, value: any) => {
        const all_lang = {
          en: 'All',
          tr: 'Hepsi',
          ar: 'الكل',
          de: 'Alle',
          es: 'Todo',
          fa: 'همه',
          ku: 'هه موو',
          vi: 'Tất cả',
          fr: 'Tous',
          hr: 'undefined',
          sq: 'undefined',
          cs: 'undefined',
          sk: 'undefined',
          ru: 'Все',
          pl: 'Wszystko',
          el: 'Όλα',
          bg: 'Всички',
          da: 'Alle',
          sr: 'Sve',
          pr: 'Tudo',
          ro: 'Toate',
          al: 'Të gjitha',
        };

        if (!value) {
          return items;
        }
        if (all_lang[wwsConfig.langCode] == value) {
          return items;
        }
        if (typeof value === 'object') {
          return items.filter(x => value.includes(x));
        }

        return items.filter(x => x[key] == value);
      };

      // Kırmızı Kart datası => GetTerminalLiveFixture içinde gönderiliyor artık ihtiyaç yok
      // const getTeamCard = (e, t) => {
      //   if (wwsConfig.cardList != null) {
      //     const card = wwsConfig.cardList.find(s => s.EventId == e);
      //     if (card != null) {
      //
      //       if (card.HomeTeamRed != null && t == 'h') {
      //         return card.HomeTeamRed;
      //       }
      //       if (card.AwayTeamRed != null && t == 'a') {
      //         return card.AwayTeamRed;
      //       }
      //
      //     }
      //   }
      // };

      const sortBy = (items: any[], reverse: boolean, sortedBy: string) => {
        let shortedData;

        if (!reverse) {
          shortedData = items.sort((a, b) => {
            const nameA = a[sortedBy];
            const nameB = b[sortedBy];
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
          });
        } else {
          shortedData = items.sort((a, b) => {
            const nameA = a[sortedBy];
            const nameB = b[sortedBy];
            if (nameA > nameB) {
              return -1;
            }
            if (nameA < nameB) {
              return 1;
            }
          });
        }

        return shortedData;
      };
      const getFavorableStates = _x => {
        const a = wwsConfig.favorable;
        return _x.map(y => {
          // ////console.log(a, y.BetradarMatchId);
          if (a == null) {
            return y;
          }
          if (a.includes(y.BetradarMatchId)) {
            y['favorableState'] = true;
            return y;
          } else {
            y['favorableState'] = false;
            return y;
          }
        });
      };
      const oddTypes = [
        ['OddValue1', 'OddValue2', 'OddValue3'],
        ['OddValueFirstScore_1', 'OddValueFirstScore_None', 'OddValueFirstScore_2'],
        ['RestThreeWay1', 'RestThreeWayX', 'RestThreeWay2'],
        ['Total1OverOddValue', 'Total1UnderOddValue', 'Total2OverOddValue', 'Total2UnderOddValue', 'Total3OverOddValue', 'Total3UnderOddValue'],
        ['OddValueFirstHalf_1', 'OddValueFirstHalf_X', 'OddValueFirstHalf_2', 'OddValueTennisFirstSet1', 'OddValueTennisFirstSet2', 'Total3UnderOddValue'],
        ['OddValueFirstHalfNG_1', 'OddValueFirstHalfNG_X', 'OddValueFirstHalfNG_2'],
        ['OddValueFirstHalfRS_1', 'OddValueFirstHalfRS_X', 'OddValueFirstHalfRS_2'],
        ['HalfTotal1OverOddValue', 'HalfTotal1UnderOddValue', 'HalfTotal2OverOddValue', 'HalfTotal2UnderOddValue', 'HalfTotal3OverOddValue', 'HalfTotal3UnderOddValue'],
        ['OddValueFirstScore_1', 'OddValueFirstScore_None', 'OddValueFirstScore_2'],
        ['OddValueRestThreeWay1', 'OddValueRestThreeWayX', 'OddValueRestThreeWay2'],
        ['OddValueTotal1Over', 'OddValueTotal1Under', 'OddValueTotal2Over', 'OddValueTotal2Under', 'OddValueTotal3Over', 'OddValueTotal3Under'],
        ['OddValueFirstHalf_1', 'OddValueFirstHalf_X', 'OddValueFirstHalf_2', 'OddValueTennisFirstSet1', 'OddValueTennisFirstSet2'],
        ['OddValueFirstHalfNG_1', 'OddValueFirstHalfNG_X', 'OddValueFirstHalfNG_2'],
        ['OddValueFirstHalfRS_1', 'OddValueFirstHalfRS_X', 'OddValueFirstHalfRS_2'],
        ['OddValueHalfTotal1Over', 'OddValueHalfTotal1Under', 'OddValueHalfTotal2Over', 'OddValueHalfTotal2Under', 'OddValueHalfTotal3Over', 'OddValueHalfTotal3Under'],
      ];
      let _sportId = -1;
      let _tournamentId = -1;

      let data;
      let dataUnfiltered;
      let dataFav;

      data = filtersPipe(wwsConfig.lml, 'SportName', wwsConfig.mfbysk);
      // ////console.log(data);
      if (data != undefined) {
        data = getFavorableStates(data);
      }
      dataUnfiltered = data;
      // Sorting//
      //En son istenilen sıralama sona gelmelidir.
      if (data != undefined) {
        if (wwsConfig.liveSortbyTime) {
          data = sortBy(data, false, 'EventDate');
          data = sortBy(data, false, 'SportId');
        } else {
          data = sortBy(data, false, 'BetradarMatchId');
          data = sortBy(data, false, 'SportId');
          data = sortBy(data, false, 'TournamentId');
          data = sortBy(data, false, 'Rank');
        }
      }
      // Sorting//
      if (wwsConfig.isLive) {
        if (wwsConfig.lfi != undefined && wwsConfig.lfi.length > 0) {
          // ////console.log("Live Filter Items : ",this._liveFilterItems);
          // Filtering tournaments if there is any tournament selected.
          /*data = wwsConfig.lfi.map(x => {
            return data.find(y => y.GroupName == x.GroupName);
          })*/

          data = data.filter(item => wwsConfig.lfi.indexOf(item.GroupName) > -1);
        }
      }

      if (data != undefined) {
        // Eğer yoksa boş array atıyoruz.
        if (!wwsConfig.favoriteData) {
          wwsConfig.favoriteData = [];
        }

        data = data.map(x => {
          x['type'] = 'Match';
          x.isFavorited = wwsConfig.favoriteData.find(betradarId => betradarId === x.BetradarMatchId);
          // Kırmızı Kart datası => GetTerminalLiveFixture içinde gönderiliyor artık ihtiyaç yok
          // x['HomeTeamRedCard'] = getTeamCard(x.EventId, 'h');
          // x['AwayTeamRedCard'] = getTeamCard(x.EventId, 'a');
          return x;
        });
      }

      const liveGoalListData = []; // Header Live Goal List
      let dataLast = [];

      if (data != undefined) {
        data.forEach(x => {
          if (wwsConfig.lfd != undefined && wwsConfig.lfd.length > 0) {
            // //console.log('--x.TournamentName--',x.TournamentName);
            // //console.log('--x.TournamentId--',x.TournamentId);

            // Bu açılırsa Ligler doğru geliyor ama Sport Ekranında Live gözükmüyor
            // if (wwsConfig.lfd.filter(s => s.TournamentId == x.TournamentId)) {
            //   return;

            // Not tournament id ler uyuşmuyor canlı ile spor arasındaki

            // Bu açılırsa Ligler doğru gelmiyor (Ex: Premier League seçilirse hem İngiltere Premier hem Başka ülkedeki Premiergeliyor ) ama Sport Ekranında Live gözüküyor
            // if (wwsConfig.lfd.filter(s => s.TournamentName.substring(0, 13) == x.TournamentName.substring(0, 13)).length==0) {
            //   return;
            // }

            // YENI TEST EDILMELI
            if (wwsConfig.lfd.filter(s => s.CategoryId == x.CategoryId).length == 0) {
              return;
            }
          }

          if (x.SportId !== _sportId) {
            _sportId = x.SportId;
            dataLast.push({
              type: 'Sport',
              SportName: x.SportName,
              SportNameOriginal: x.SportNameOriginal,
              SportId: x.SportId,
              TournamentId: x.TournamentId,
              BetradarMatchId: x.TournamentId,
            });
          }
          if (x.TournamentId !== _tournamentId) {
            _tournamentId = x.TournamentId;
            dataLast.push({
              type: 'TournamentName',
              TournamentName: x.CategoryName + '/' + x.TournamentName,
              SportNameOriginal: x.SportNameOriginal,
              TournamentNameShort: x.TournamentName,
              SportName: x.SportName + '/' + x.CategoryName,
              TournamentId: x.TournamentId,
              IsoName: x.IsoName,
              BetradarMatchId: x.TournamentId,
            });
          }

          if (wwsConfig.old_lml != undefined) {
            const _oldMATCHITEM = wwsConfig.old_lml.find(s => s.EventId == x.EventId);
            if (_oldMATCHITEM != undefined) {
              // x.MatchTimeExtended != _oldMATCHITEM.MatchTimeExtended
              // x.Score != _oldMATCHITEM.Score

              // GOAL ANIMATION
              if (x.Score != _oldMATCHITEM.Score) {
                x['goalcss'] = 'goal';
                // console.log('---GOAL---',JSON.stringify(x.HomeTeam),JSON.stringify(x.AwayTeam),JSON.stringify(x.Score));
              }

              if (x.SportId == 1) {
                if (x.HomeScore != _oldMATCHITEM.HomeScore && x.HomeScore != '0' && x.HomeScore != '' && x.HomeScore != undefined) {
                  liveGoalListData.push({
                    homeScore: x.HomeScore,
                    awayScore: x.AwayScore,
                    homeTeam: x.HomeTeam,
                    awayTeam: x.AwayTeam,
                    homeGoal: true,
                    awayGoal: false,
                    visible: false,
                  });
                  x['homegoalcss'] = 'teamgoal';
                }

                if (x.AwayScore != _oldMATCHITEM.AwayScore && x.AwayScore != '0' && x.AwayScore != '' && x.AwayScore != undefined) {
                  // Header da Goal Animasyonu için
                  liveGoalListData.push({
                    homeScore: x.HomeScore,
                    awayScore: x.AwayScore,
                    homeTeam: x.HomeTeam,
                    awayTeam: x.AwayTeam,
                    homeGoal: false,
                    awayGoal: true,
                    visible: false,
                  });
                  // Match Row da Goal Animasyonu için
                  x['awaygoalcss'] = 'teamgoal';
                }
              }

              wwsConfig.oddtype.forEach(_y => {
                // (oddTypes[_y], _y);
                oddTypes[_y].forEach(z => {
                  _oldMATCHITEM[z] > x[z] ? (x[z + 'css'] = 'downarrow') : null;
                  _oldMATCHITEM[z] < x[z] ? (x[z + 'css'] = 'uparrow') : null;
                });
              });
            }
          }
          // ////console.log(x);
          dataLast.push(x);
        });
      }
      // a1.filter(item => a2.indexOf(item) < 0);
      // ////console.log("live favs : ",wwsConfig.favorable);

      // 03.09.2021 de Kapatıldı
      // dataFav = dataLast.filter(item => wwsConfig.favorable.indexOf(item.BetradarMatchId) > -1);

      if (wwsConfig.liveFavoriteButtonStatus && wwsConfig.liveFavoriteData.length > 0) {
        dataLast = dataLast.filter(item => wwsConfig.liveFavoriteData.indexOf(item.TournamentId) > -1);
      } else if (wwsConfig.liveFavoriteButtonStatus && wwsConfig.favorable.length > 0) {
        dataLast = dataLast.filter(item => wwsConfig.favorable.indexOf(item.BetradarMatchId) > -1);
      }

      return { dt: dataLast, dtUn: dataUnfiltered, dtFavs: dataFav, liveGoalListData: liveGoalListData, time: wwsConfig.time };
    } catch (e) {
      console.error(e);
    }
  };

  // Kırmızı Kart datası => GetTerminalLiveFixture içinde gönderiliyor artık ihtiyaç yok
  // setCardData(v) {
  //   this.cardData = v;
  //   this.cardDataListener.emit(this.cardData);
  // }

  setLiveEventDetailsData(v: Array<any>) {
    this.liveEventDetailData = v;
    this.liveEventDetailListener.emit(this.liveEventDetailData);
  }

  setLeftMenuSportData(v: Array<any>, dayFilter) {
    this.leftMenuSportData = v;
    this.leftMenuSportDataListener.emit(this.leftMenuSportData);
    this.leftMenuSportDayFilter = dayFilter;
  }

  setSearchData(v) {
    // console.log('--setSearchData--',v);
    this.searchData = v;
    this.searchDataListener.emit(this.searchData);
  }

  setSearchDataViaUrl(v) {
    // console.log('--setSearchDataViaUrl--',v);
    this.searchData = v;
    this.searchDataUrlListener.emit(v);
  }

  setCurrentSlipData(v) {
    // console.log('setCurrentSlipData, ', v);
    this.currentSlipData = [...v];
    this.currentSlipDataListener.emit(this.currentSlipData);
    this.numberOfBetsListener.emit(this.currentSlipData.length);
    this.numberOfBets = this.currentSlipData.length;

    const transformedData = this._GroupByEventName.transform(this.currentSlipData.reverse(), null);
    transformedData.find(element => (this.currentSlipInfo.isMultiWaySystem = element.eEvents && element.eEvents.length > 1));
  }

  setTaxRate(v) {
    this.taxRate = v;
    //// console.log('TAX_RATE', this.taxRate);
  }

  setCashoutData(v) {
    if (!v) {
      return;
    }

    this.cashoutData = v;
    this.cashoutDataListener.emit(this.cashoutData);
    this.numberOfCashoutListener.emit(this.cashoutData.length);
    this.numberOfCashout = this.cashoutData.length;
    this.cashoutSlipsList = v.map(newCashoutItem => {
      const _cashoutOldItem = this.cashoutSlipsList.find(y => y.SlipId === newCashoutItem.SlipId);
      if (_cashoutOldItem) {
        // Merge two datas.
        // Old data can contain cashout value.

        newCashoutItem = {
          ..._cashoutOldItem,
          ...newCashoutItem, // new one replaces old one.

          // Below fields are not in CashOutSlipsExternal data.
          CashoutValue: _cashoutOldItem.CashoutValue,
          CashoutSlipDetails: _cashoutOldItem.CashoutSlipDetails,
          State: _cashoutOldItem.State,
          isLive: _cashoutOldItem.isLive,
          details: _cashoutOldItem.details,
        };
      }
      return newCashoutItem;
    });
  }

  setSideBannerData(v) {
    this.sideBannerData = v;
    this.sideBannerDataListener.emit(this.sideBannerData);
  }

  setLiveGoalListData(e) {
    this.liveGoalListData = e;
    this.liveGoalListDataListener.emit(this.liveGoalListData);
  }
  setHomeSliderData(e) {
    this.homeSliderData = e;
    this.homeSliderDataListener.emit(this.homeSliderData);
  }

  setCurrentSlipAmount(data) {
    this.currentSlipAmount = data;
    this.currentSlipAmountListener.emit(this.currentSlipAmount);
  }

  setCurrentSlipSystemInfo(data) {
    this.currentSlipSystemSelection = this.currentSlipSystemSelection.filter(item => data.filter(i => `${i.index + 1}_${i.combination}` === item).length > 0);
    this.currentSlipSystemInfo = data;
    if (data.filter(i => i.selection).length > 0) {
      this.currentSlipInfo.isCheckIsSystem = true;
    } else {
      this.currentSlipInfo.isCheckIsSystem = false;
    }

    this.currentSlipSystemInfoListener.emit(this.currentSlipSystemInfo);
  }

  setComparisonData(data) {
    this.comparisonData = data;
    this.comparisonDataListener.emit(this.comparisonData);
  }
}
